<template>
  <div>
    <mt-loadmore :top-method="loadTop" ref="loadmore">
    <div class="detail-header">
      <div class="clearfix">
        <a class="img-back white pull-left" style="padding-left:15px;margin-left:0;" href="javascript:window.history.go(-1)">返回</a>
        <router-link class="pull-right white" :to="{'path':'/student/edit/' + studentId}">编辑</router-link>
      </div>
      <div class="text-center">
        <span class="block img-wrap big"><img :src="info.image_address ? (info.baseAcessPath + info.image_address) : img_default" width="100%"></span>
        <span class="font-16 block margin-15">{{info.studentName}}</span>
      </div><p></p>
    </div>

    <div>
      <ul class="list-group-item tinny">
        <li class="list-group">
          <div class="liner"></div>
          <div class="clearfix  group-txt">
            <span class="pull-left">生日：</span>
            <span class="pull-right gray">{{info.studentBirthday ? info.studentBirthday : '未填写'}}</span>
          </div>
        </li>
        <li class="list-group">
          <div class="liner"></div>
          <div class="clearfix  group-txt">
            <span class="pull-left">性别：</span>
            <i v-bind:class="info.sex == '男' ? 'img-sex boy' : 'img-sex girl'" style="float:right">{{info.sex}}</i>
          </div>
        </li>
        <li class="list-group hide">
          <div class="liner"></div>
          <div class="clearfix  group-txt">
            <span class="pull-left">编入班级：</span>
            <span class="pull-right gray" v-if="info.relation_className">{{info.relation_className}}</span>
            <span class="pull-right orange" v-else>未编入班级</span>
          </div>
        </li>
        <li class="list-group">
          <div class="liner"></div>
          <div class="clearfix group-txt">
            <span class="pull-left">托管服务:</span>
            <span class="pull-right gray">
            {{info.typeName ? info.typeName : '未添加托管服务'}}
            </span>
          </div>
        </li>
        <!-- <li class="list-group">
          <div class="liner"></div>
          <a href="#" class="clearfix group-txt img-more">
            <span class="pull-left">缴费记录:</span>
            <span class="pull-right orange" style="margin-right:20px">当月未缴</span>
          </a>
        </li> -->
        <li class="list-group">
          <div class="liner"></div>
          <div class="clearfix group-txt">
            <span class="pull-left">所在学校:</span>
            <span class="pull-right gray">{{(info.szxx ? info.szxx : '') + ' ' + (info.grade ? info.grade : '未填写')}}</span>
          </div>
        </li>
        <li class="list-group" v-if="!hideInsurance">
          <div class="liner"></div>
          <router-link :to="{'path':'/insurance/insurance-pdf/' + insuranceInfo[0].insure_url}" class="clearfix group-txt img-more">
            <span class="pull-left">安全保障:</span>
            <span class="pull-right green margin-x-15">{{insuranceInfo[0].insure_name}}</span>
          </router-link>
        </li>
      </ul>

      <strong class="block margin-x-15">关联家长</strong>
      <ul class="list-group-item tinny">
        <li class="list-group" v-for="item in info.parentList">
          <div class="liner"></div>
          <div class="clearfix  group-txt">
            <span class="pull-left">{{item.parentRole}}</span>
            <span class="pull-left margin-x-15 gray" v-if="item.djlxr == 1">第一联系人</span>
            <a :href="'tel:' + item.phoneNum" class="pull-right gray">{{item.phoneNum}}</a>
          </div>
        </li>
        <template v-if="info.parentList && info.parentList.length == 0">
          <li class="list-group">
            <div class="liner"></div>
            <a class="clearfix group-txt">
              <span class="pull-left">监护角色：</span>
              <span class="pull-right gray margin-x-15">{{info.parentRole}}</span>
            </a>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix group-txt">
              <span class="pull-left">手机号码：</span>
              <span class="pull-right gray margin-x-15">{{info.parentPhone}}</span>
            </div>
          </li>
        </template>
      </ul>
    </div>
    </mt-loadmore>
  </div>
</template>

<script>
import { service } from '../../service'
export default {
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      get_student_msg_para: service.setPara('getStudentMsg'),
      get_student_insure_List_para: service.setPara('getStudentInsureList'),
      info: {},
      insuranceInfo: [],
      studentId: 0,
      hideInsurance: true
    }
  },
  mounted: function () {
    this.studentId = this.$route.params.studentId
    this.getStudentMsg()
    this.getStudentInsureListMsg()
  },
  methods: {
    loadTop (id) {
      this.getStudentMsg()
      this.getStudentInsureListMsg()
      this.$refs.loadmore.onTopLoaded(id)
    },
    getStudentMsg: function () {
      this.get_student_msg_para.studentId = this.studentId

      let that = this
      let obj = {context: this, para: this.get_student_msg_para, successFun: (response) => {
        that.info = response.data
      }}
      service.request(obj)
    },
    getStudentInsureListMsg: function () {
      this.get_student_insure_List_para.studentId = this.studentId
      let that = this
      let obj = {context: this, para: this.get_student_insure_List_para, successFun: (response) => {
        that.insuranceInfo = response.data
        if (that.insuranceInfo.length == 0) {
          that.hideInsurance = true
        } else {
          that.hideInsurance = false
        }
      }}
      service.request(obj)
    }
  }
}
</script>


// WEBPACK FOOTER //
// StudentDetail.vue?984fed1a